const VARIABLE_PATH_SEGMENT_PATTERN = /([^[.\]]+)|\[(\d+)\]/g

const parseVariablePath = (path) => {
  if (typeof path !== 'string' || path.trim() === '') {
    return []
  }

  const segments = []
  const normalizedPath = path.trim()

  VARIABLE_PATH_SEGMENT_PATTERN.lastIndex = 0

  let match = VARIABLE_PATH_SEGMENT_PATTERN.exec(normalizedPath)

  while (match !== null) {
    if (match[1] !== undefined) {
      segments.push(match[1])
    } else if (match[2] !== undefined) {
      segments.push(Number(match[2]))
    }

    match = VARIABLE_PATH_SEGMENT_PATTERN.exec(normalizedPath)
  }

  return segments
}

const cloneValue = (value) => {
  if (Array.isArray(value)) {
    return value.map((entry) => cloneValue(entry))
  }

  if (value && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value).map(([key, entry]) => [key, cloneValue(entry)])
    )
  }

  return value
}

const setNestedValue = (target, path, value) => {
  const segments = parseVariablePath(path)

  if (segments.length === 0) {
    return target
  }

  let currentNode = target

  for (let index = 0; index < segments.length; index += 1) {
    const segment = segments[index]
    const nextSegment = segments[index + 1]
    const isLastSegment = index === segments.length - 1

    if (isLastSegment) {
      currentNode[segment] = cloneValue(value)
      continue
    }

    const expectsArray = typeof nextSegment === 'number'

    if (currentNode[segment] === undefined || currentNode[segment] === null) {
      currentNode[segment] = expectsArray ? [] : {}
    }

    currentNode = currentNode[segment]
  }

  return target
}

export const normalizeTaskTemplateVariableErrorPath = (path) => {
  if (typeof path !== 'string' || path.trim() === '') {
    return ''
  }

  return path.trim().replace(/\[(\d+)\]/g, '.$1')
}

export const buildInitialTaskTemplateVariableValues = (variablesSchema = []) => {
  return Object.fromEntries(
    (Array.isArray(variablesSchema) ? variablesSchema : [])
      .map((schemaEntry) => {
        const key = typeof schemaEntry?.key === 'string' ? schemaEntry.key : ''

        if (key === '') {
          return [key, '']
        }

        if (schemaEntry?.default === null || schemaEntry?.default === undefined) {
          return [key, '']
        }

        if (typeof schemaEntry.default === 'string') {
          return [key, schemaEntry.default]
        }

        return [key, JSON.stringify(schemaEntry.default)]
      })
      .filter(([key]) => key !== '')
  )
}

export const buildTaskTemplateLaunchVariablesPayload = (variableValues = {}) => {
  const payload = {}

  for (const [path, value] of Object.entries(variableValues)) {
    if (typeof path !== 'string' || path.trim() === '') {
      continue
    }

    if (value === null || value === undefined) {
      continue
    }

    if (typeof value === 'string' && value.trim() === '') {
      continue
    }

    setNestedValue(payload, path, value)
  }

  return payload
}

export const resolveTaskTemplateVariableError = (errors = {}, path) => {
  if (!errors || typeof errors !== 'object' || Array.isArray(errors)) {
    return ''
  }

  const fieldErrors = errors[`variables.${normalizeTaskTemplateVariableErrorPath(path)}`]

  if (!Array.isArray(fieldErrors) || fieldErrors.length === 0) {
    return ''
  }

  return typeof fieldErrors[0] === 'string' ? fieldErrors[0] : ''
}

export const formatTaskTemplateVariableSources = (sources = []) => {
  if (!Array.isArray(sources)) {
    return ''
  }

  return sources
    .filter((source) => typeof source === 'string' && source.trim() !== '')
    .join(', ')
}
